// extracted by mini-css-extract-plugin
export default {"galleryContainer":"Certifications_galleryContainer__0zN5R","galleryHolder":"Certifications_galleryHolder__PA+vE","backHomeSection":"Certifications_backHomeSection__E6HWQ"};